import { render, staticRenderFns } from "./ShipExperience.vue?vue&type=template&id=20a94799&scoped=true"
import script from "./ShipExperience.vue?vue&type=script&lang=js"
export * from "./ShipExperience.vue?vue&type=script&lang=js"
import style0 from "./ShipExperience.vue?vue&type=style&index=0&id=20a94799&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a94799",
  null
  
)

export default component.exports